import React from 'react';
import { ArrowDownIcon, SearchIcon, TargetIcon, PlayCircleIcon } from 'lucide-react';
import { Card, CardLabel, DarkCard, Fade, Hi, Slide, SlideHeader } from '../deck/Slide';
const layers = [{
  icon: PlayCircleIcon,
  label: 'Snakker layer',
  title: 'Short-form snaks on top of your pages',
  body: 'Keeps the content current, keeps attention alive, and surfaces an HVA wherever the HCP lands.',
  tone: 'accent' as const
}, {
  icon: SearchIcon,
  label: 'Your layer',
  title: 'SEO optimized long-form content',
  body: 'Earns the ranking and brings the eyeballs in. We do not touch it, we multiply what it returns.',
  tone: 'plain' as const
}];
export function EngagementLayerSlide() {
  return <Slide data-id="element-108" data-mp="2bpal6tpsxu99">
      <SlideHeader eyebrow="The jigsaw piece" data-id="element-109" data-mp="2bpk8uandjpbs">
        We aren&rsquo;t replacing your web strategy. We{' '}
        <Hi data-id="element-110" data-mp="2pmh20iqytivu">double the return on it.</Hi>
      </SlideHeader>

      <div className="grid min-h-0 flex-1 grid-cols-12 gap-[clamp(1.25rem,2.5vw,2.5rem)]" data-id="element-111" data-mp="2kqi8yhuozcp3">
        <div className="col-span-8 flex min-h-0 flex-col gap-[clamp(0.5rem,1vw,1rem)]" data-id="element-112" data-mp="33zmnhy4h989m">
          {layers.map((layer, index) => <Fade key={layer.label} delay={0.2 + index * 0.1} className="flex flex-1" data-id="element-113" data-mp="38xwhw6ido4u6" data-mpi={index}>
              {layer.tone === 'accent' ? <div className="flex flex-1 items-center gap-5 rounded-2xl bg-[var(--brand-green-light)] p-[clamp(1.1rem,1.8vw,1.8rem)] text-white shadow-sm" data-id="element-114" data-mp="3ivke70vmtkeg">
                  <layer.icon className="h-8 w-8 flex-shrink-0" aria-hidden="true" data-id="element-115" data-mp="3mx5m07tb78hs" />
                  <div data-id="element-116" data-mp="3rv7f7lkg8o6z">
                    <p className="text-[clamp(0.7rem,0.95vw,0.9rem)] font-bold uppercase tracking-wider text-white/80" data-id="element-117" data-mp="3rufkse2l8wia">
                      {layer.label}
                    </p>
                    <h3 className="mt-1 text-[clamp(1.05rem,1.6vw,1.6rem)] font-bold leading-tight" data-id="element-118" data-mp="5ged67xwjdxz">
                      {layer.title}
                    </h3>
                    <p className="mt-1 text-[clamp(0.85rem,1vw,1rem)] leading-relaxed text-white/85" data-id="element-119" data-mp="eh44ozg4qi5w">
                      {layer.body}
                    </p>
                  </div>
                </div> : <Card className="flex flex-1 items-center gap-5" data-id="element-120" data-mp="26kghbkn95w24">
                  <layer.icon className="h-8 w-8 flex-shrink-0 text-[var(--brand-green)]" aria-hidden="true" data-id="element-121" data-mp="2kb3h7g4r1rzs" />
                  <div data-id="element-122" data-mp="2fi0kx08l84fw">
                    <CardLabel tone="muted" data-id="element-123" data-mp="2u8hmqkp4wwdb">{layer.label}</CardLabel>
                    <h3 className="mt-1 text-[clamp(1.05rem,1.6vw,1.6rem)] font-bold leading-tight text-[var(--fg)]" data-id="element-124" data-mp="2uauc3ix8290e">
                      {layer.title}
                    </h3>
                    <p className="mt-1 text-[clamp(0.85rem,1vw,1rem)] leading-relaxed text-[var(--muted)]" data-id="element-125" data-mp="338warrthgpki">
                      {layer.body}
                    </p>
                  </div>
                </Card>}
            </Fade>)}

          <Fade delay={0.4} className="flex items-center justify-center gap-3" data-id="element-126" data-mp="14ubcfwpw0mv4">
            <ArrowDownIcon className="h-5 w-5 text-[var(--brand-green)]" aria-hidden="true" data-id="element-127" data-mp="upv37m6wy40a" />
            <span className="text-[clamp(0.8rem,1vw,1rem)] font-semibold uppercase tracking-wide text-[var(--muted)]" data-id="element-128" data-mp="yqevabcmqhfk">
              Same investment, working twice
            </span>
          </Fade>
        </div>

        <Fade delay={0.5} className="col-span-4 flex" data-id="element-129" data-mp="pxv41vyo3f4r">
          <DarkCard className="flex flex-1 flex-col justify-center" data-id="element-130" data-mp="b25e5mqd2hur">
            <TargetIcon className="h-8 w-8 text-[var(--brand-green-lighter)]" aria-hidden="true" data-id="element-131" data-mp="b4045fghp05p" />
            <p className="mt-4 text-[clamp(1.3rem,2.2vw,2.2rem)] font-bold leading-tight" data-id="element-132" data-mp="21qraixr0up5">
              High Value Actions, everywhere
            </p>
            <p className="mt-3 text-[clamp(0.85rem,1.05vw,1.05rem)] leading-relaxed text-white/70" data-id="element-133" data-mp="70k4ea94ijos">
              Once to rank, once to convert. Every page gets a next step instead
              of a dead end.
            </p>
          </DarkCard>
        </Fade>
      </div>
    </Slide>;
}